import zeroPad from './zeroPad';

const getFullDate = (date: Date) =>
  `${date.getFullYear()}-${zeroPad(date.getMonth() + 1, 2)}-${zeroPad(date.getDate(), 2)}`;

export default getFullDate;
